module.exports = __webpack_public_path__ + "img/level_three_lock.40b611f8.png";